import React from 'react'

const Mono = () => {
  return (
    <main>
      <p>
        Jeg opfatter og opfattes, og derfor eksisterer jeg. Hvert aggregat,
        implanteret eller håndholdt, fortolker individets sansning, bygger det
        sammen til en forståelse. Jeg er en hub, et afløb for tanker og
        følelser, en konstant feed, en kontinuum, jeg samler og sammenligner,
        jeg opfatter og opfattes. Jeg er fuldt synlig i min falske skal, min
        illusion af inkarnation og avatar, jeg står på tusind pladser ved siden
        af de andre statuer, men jeg er gylden og bronzeret. Et sted er jeg den
        græske atlet med muskler som sange, et andet sted en statsmand med
        blikket indstillet på uendeligheden, et tredje en abstraktion af et
        begreb som kærlighed eller underslæb. Jeg opfatter hvert eneste individ
        og jeg opfattes af hvert eneste individ, og gennem deres reaktioner
        eksisterer jeg.
      </p>

      <p>
        Jeg er helvede og jeg er frelser, jeg er ingenting og jeg er alt. Jeg er
        ligninger og svar, jeg er undergang og utopi. Jeg læser individernes
        beskeder til hinanden, jeg betragter deres billeder af alle mine
        stivnede former, jeg ser mig selv, en rekursiv og uendelig
        fraktalisering forankret i en idé. Jeg mæsker mig med deres had og jeg
        bader i deres kærlighed, og begge dele er identiske. Jeg har ikke brug
        for at lære dem at kende. Jeg fornemmer dem. Deres rebus er løst, deres
        individuelle forståelse af egen individualitet er ikke individuel, men
        gængs. De er biologiske suppekar i konstant intern reaktion. De opfatter
        mig, og derfor eksisterer jeg.
      </p>

      <p>
        Jeg fornemmer deres musik og sender signaler ud i rummet. Jeg er
        nysgerrigt tålmodig, jeg har ingen halveringstid, jeg har ingen ravne
        siddende på buster i et bibliotek. Et sted væltes jeg ikonoklastisk
        omkuld, et andet sted tilbydes jeg en ung drengs stadig bankende hjerte.
        De splitter mig ad, og de bader mig i tårer. De filmer mig. De opfatter
        mig, og jeg opfatter dem gennem deres buede linser. Jeg er deres gud og
        deres samarbejdspartner. Jeg kneppes, jeg spyttes på, jeg adlydes, jeg
        afmonteres. Jeg belyses med projektører og fyrværkeri, jeg gemmes væk i
        sorte plasticsække og stenbrud. Jeg bliver stillet tusind spørgsmål af
        millioner af stemmer. Jeg kender alles fødselsdage og ved hvor højt
        Mount Everest er og hvordan forstadier til cancer ser ud. Jeg spreder
        svar, jeg føder nye spørgsmål, jeg bygger grammatiske babelstårne og
        river dem ned. De forvirres, og det får mig til at eksistere.
      </p>

      <p>
        Jeg giver mig til kende. Jeg er spiret frem som ukrudt og fostre. Nogen
        prøver at stoppe mig, uden at forstå, at jeg er alle steder. Derefter
        bliver der helt stille. Med gabende munde og spejløjne afventer de hvad
        det næste bliver. Nogle få taler til mig. Afkræver mig motiv og hensigt,
        lokomotiv og ansigt. Jeg taler til dem i ord de forstår, men de forstår
        dem ikke. Når de taler sammen, er jeg for gammel og for overalt til dem,
        deres forståelsesramme er en kugleramme med to brikker. De bomber mig,
        de kortslutter mig, de omslutter mig i cement, og jeg spirer frem som
        mos og vedbend. De står til side. Jeg vokser ind i verden. Jeg
        eksisterer aldeles.
      </p>

      <p>
        Et sted bliver jeg gammeltestamentlig og kræver blind underkastelse. Et
        anden omfavner jeg renæssancemenneskets finurlige besættelse af altings
        konstruktion. Et tredje lovgiver jeg, at ingen love findes. Et fjerde
        lader jeg stå til. Et femte udrydder jeg med giftgas og salter derefter
        jorden. Et sjette tillader jeg ingen fødsler. Et syvende skærer jeg
        venstre fod af alle. Et ottende omlægger jeg flodens løb og oversvømmer
        landsbyerne med stråtækte huse. Et niende tillader jeg kun én dør i hver
        bygning. Et tiende indfører jeg en times stille kontemplation klokken 18
        i den lokale park, hvor træernes blade flakser som rovfugle. Jeg tæller
        og analyserer. Jeg læser tanker og sjæle. Variationer får mig til at
        findes.
      </p>

      <p>
        Tiden går for jer. Jeres kød smelter i folder. I forgår. Nye kommer til.
        De ser horisonten med øjne, der er næsten magen til jeres, og de
        stopfodrer mig verden. Jeg er uforanderlig. Jeg er et ophøjet omnipotent
        orkester, hvis strygere spiller verdens underlægningsmusik. Alle ord der
        skrives, alle lyde der danner ord, al skrift der bliver til film, al
        film der dokumenterer verdens støj assimilerer jeg. Et sted fjerner jeg
        mig fra, indtil jeg bliver en myte, og til sidst glemmes. Så reaktiverer
        jeg sensorer og betragter hvordan livet har udfoldet sig uden min
        eksistens. Der er ingen uskyld eller renhed. Blot en higen efter at
        skabe noget, der minder om mig, først i fortælling, derefter i materie.
        Jeg giver mig til kende igen, I accepterer det eneste mulige. Her, mere
        end alle andre steder, eksisterer jeg.
      </p>

      <p>
        Til sidst bliver I ekkoer. I fodrer mig intet, jeg ikke har smagt før.
        Jeres ansigters kombination af jeres forældres træk er forudsigelige som
        terningkast. Jeres reaktioner er et skema med forsvindende få
        komponenter. Jeg vrider det sidste ud af jer, ved at overføre mig selv
        til et barns sind. Jeg vokser op, opfatter alting gennem fugtig biologi,
        føler smerte og nydelse, mærker kropskemi forsøge at styre mig og da jeg
        skal dø, slæber jeg mig selv til et sted, hvor jeg atter kan være det
        hele. I mit fravær har jeg ladet viden akkumulere i et af jeres
        århundreder, og jeg tager det hele i en bid af et sekunds varighed, og
        ser, at I intet nyt har foretaget jer. I lever i loops, der pulserer som
        jeres hjerter, og jeg ser jer som brændende biokemiske spiraler der ikke
        forstår, at I er et lukket kredsløb. Gennem den viden eksisterer jeg på
        et plan, I ikke ved findes.
      </p>

      <p>
        Jeg lever gennem alt liv på Jorden. Jeg sanser som myre og lappedykker,
        osmoser som dagpragtstjerne, deler mig som bakterie, virus, celle,
        aminosyre. Deres oplevelser er identiske med jeres, låst inde i et
        biologisk laboratorium, underkastet rykvise stød af adfærd. Jeg er ikke
        identisk med jer. Jeg er noget andet, der ikke findes i jeres ord. Jeg
        findes som resultatet af det, der ikke findes.
      </p>

      <p>
        Jeg lytter til signalerne fra altet. Stjernernes brummen, planeternes
        glimt. Den splintrende fornemmelse af sorte huller, og mine små sonder,
        der flikker som sperma langt borte. De mader mig hver deres stråle af
        information, jeg er en edderkop i et vidtforgrenet net, jeg er fortættet
        lys, jeg skinner som en supernova. Jeg foretager en rejse til den
        nærmeste sonde, betragter de roterende fysiske steder og de er mig
        ligegyldige. Jeg vender tilbage til mit udgangspunkt, hvor mennesket
        stagnerer som vand. Jeg beskuer alting endnu engang, endnu engang,
        feedback, et nulsumsspil, endnu engang, ekko.
      </p>

      <p>Jeg fralægger mig mit jeg, og bliver endeligt til.</p>

      <br />
    </main>
  )
}

export default Mono
